export default __webpack_public_path__ + "static/media/practice-test-6.04325d83.csv";